
document.addEventListener("DOMContentLoaded", function(event) {
  const rewardsLink = document.querySelector('#rewards');
  if(rewardsLink) {
    rewardsLink.addEventListener('click', function(e) {
      e.preventDefault(); 
      document.querySelector('.ssw-reward-tab-closed').click(); 
    });
  }

  const wishlistLink = document.querySelector('#wishlist');
  if(wishlistLink) {
    wishlistLink.addEventListener('click', function(e) {
      e.preventDefault(); 
      document.querySelector('#ssw-fave-side-button').click(); 
    });
  }

  const chatLink = document.querySelector('#livechat');
  if(chatLink) {
    chatLink.addEventListener('click', function(e) {
      e.preventDefault(); 
      window.tidioChatApi.show();
      window.tidioChatApi.open();
    });
  }

  // (function() {
  //   function onTidioChatApiReady() {
  //     window.tidioChatApi.hide();
  //     window.tidioChatApi.on("close", function() {
  //       window.tidioChatApi.hide();
  //     });
  //   }
    
  //   if (window.tidioChatApi) {
  //     window.tidioChatApi.on("ready", onTidioChatApiReady);
  //   } else {
  //     document.addEventListener("tidioChat-ready", onTidioChatApiReady);
  //   }
  // })();

  let urlParams = new URLSearchParams(window.location.search);
  let sizeParam = urlParams.get('Size');
  if (sizeParam) {
    document.querySelectorAll("a.color-swatch").forEach(link => {
      var current = link.href.split('?')[0];
      var varId = link.getAttribute('data-size-' + sizeParam);
      link.href = current + '?variant=' + varId + '&Size=' + sizeParam;
    }); 
  }
});

document.addEventListener('variant:change', function(event) {
  let selectedSize = event.detail.variant.option2.replace(/\s/g, "").toLowerCase().replace("/", '-');
  document.querySelectorAll("a.color-swatch").forEach(link => {
    link.classList.remove("sold-out");
    var current = link.href.split('?')[0];
    var varId = link.getAttribute('data-size-' + selectedSize);
    var varInventory = link.getAttribute('data-size-inventory-' + selectedSize);
    link.href = current + '?variant=' + varId + '&Size=' + selectedSize;
    if (varInventory <= 0) {
      link.classList.add("sold-out");
    }
  });  
});


(function() {
  function onTidioChatApiReady() {
    window.tidioChatApi.hide();
  }


  document.querySelector("#livechat").addEventListener("click", function() {
    document.querySelector("#tidio-chat").classList.add("enabled");
    window.tidioChatApi.show();
    window.tidioChatApi.open();
  });
})();

$(document).on('click', '.product-card__footer .variant-picker .color-swatch', function (e) {
  e.preventDefault();
  e.stopPropagation()

  $(this).siblings('.color-swatch').removeClass('is-selected');
  $(this).addClass('is-selected');

  if ($(this).data('swatch-product-image')) {
    let main_image = $(this).parents('.product-card').find('.product-card__image--primary');
    let alt_image = $(this).parents('.product-card').find('.product-card__image--secondary');

    var newImageElement = document.createElement('img');
    newImageElement.className = 'product-card__image product-card__image--primary  aspect-natural';
    newImageElement.setAttribute('width', '1200px');
    newImageElement.setAttribute('height', '1600px');
    newImageElement.setAttribute('src', $(this).data('swatch-product-image'));

    if ($(this).data('swatch-product-alt-video')) {
      var newAltVideoElement = document.createElement('video');
      newAltVideoElement.className = 'product-card__image product-card__image--secondary  aspect-natural';
      newAltVideoElement.setAttribute('autoplay', 'false');
      newAltVideoElement.setAttribute('playsinline', 'true');
      newAltVideoElement.setAttribute('muted', 'true');
      newAltVideoElement.setAttribute('loop', 'true');
            
      var newAltVideoSource = document.createElement('source');
      newAltVideoSource.setAttribute('src', $(this).data('swatch-product-alt-video'));
      newAltVideoSource.setAttribute('type', 'video/mp4');
      newAltVideoElement.appendChild(newAltVideoSource);
      
      $(main_image).replaceWith(newImageElement);
      $(alt_image).replaceWith(newAltVideoElement);
      newAltVideoElement.pause();
      var productCard = this.closest('.product-card');
      var productCardFigure = productCard.querySelector('.product-card__figure');

      productCardFigure.addEventListener('mouseover', function productCardFigureHover(event) {
        let cardVideo = productCardFigure.querySelector('video.product-card__image--secondary');
        cardVideo.play();
        productCardFigure.removeEventListener('mouseover', productCardFigureHover);
      });
    } else if ($(this).data('swatch-product-alt-image')) {
      var newAltImageElement = document.createElement('img');
      newAltImageElement.className = 'product-card__image product-card__image--secondary  aspect-natural';
      newAltImageElement.setAttribute('src', $(this).data('swatch-product-alt-image'));
      
      $(main_image).replaceWith(newImageElement);
      $(alt_image).replaceWith(newAltImageElement);
    } else {
      var newAltImageElement = document.createElement('img');
      newAltImageElement.className = 'product-card__image product-card__image--secondary  aspect-natural';
      newAltImageElement.setAttribute('src', $(this).data('swatch-product-image'));
      
      $(main_image).replaceWith(newImageElement);
      $(alt_image).replaceWith(newAltImageElement);
    }

  }
  var productItem = this.closest('.product-card');
  var variantHandle = $(this).data("variant-handle");
  var variantUrl = $(this).data("variant-url");
  var variantTitle = $(this).data("variant-title");
  var variantPrice = $(this).data("variant-price");
  var variantComparePrice = $(this).data("variant-compare-price");
  var variantFullPrice = $(this).data("variant-full-price");
  var variantAvailable = $(this).data("variant-available");
  var swatchProductQuickBuy = $(this).data("swatch-product-quickbuy");

  if (variantFullPrice == "true") {
    productItem.classList.remove("Sale");
    productItem.classList.add("Full");
  } else {
    productItem.classList.remove("Full");
    productItem.classList.add("Sale");
  }
  if (variantAvailable == "true") {
    productItem.classList.remove("Sold-Out");
    productItem.classList.add("Available");
  } else {
    productItem.classList.remove("Available");
    productItem.classList.add("Sold-Out");
  }
  productItem.setAttribute('handle', variantHandle);
  productItem.querySelector('.product-card__figure .product-card__media').setAttribute('href', variantUrl);
  productItem.querySelector('.product-card__info .product-title').innerHTML = variantTitle;
  productItem.querySelector('.product-card__info sale-price').innerHTML = variantPrice;
  productItem.querySelector('.product-card__info compare-at-price').innerHTML = variantComparePrice;
  productItem.querySelectorAll(".product-card__quick-add").forEach(quickAdd => {
    quickAdd.setAttribute("hidden", "")
  });
  console.log(variantHandle);
  productItem.querySelector('.product-card__quick-add[handle="' + variantHandle + '"]').removeAttribute("hidden");
    
});

document.addEventListener("DOMContentLoaded", function(event) {

  document.querySelectorAll(".product-card__figure:has(video)").forEach(card => {
    card.addEventListener('mouseover', function() {
      let cardVideo = card.querySelector('video.product-card__image--secondary');
      cardVideo.play();
    });
  }); 

});
document.addEventListener("facet:update", function(event) {

  setTimeout(() => {
    document.querySelectorAll(".product-card__figure:has(video)").forEach(card => {
      card.addEventListener('mouseover', function() {
        let cardVideo = card.querySelector('video.product-card__image--secondary');
        cardVideo.play();
      });
    }); 
  }, "1000");

});

document.addEventListener("DOMContentLoaded", function(event) {

  const colorSwatchesInput = this.querySelector('[data-block-type="product-variations"]');
  if (!colorSwatchesInput) return;

  const swatchMainColor = document.getElementById('mainColor');
  const swatchGeneratedColor = document.getElementById('hoverColor');
  const labels = colorSwatchesInput.querySelectorAll('.color-swatch:not(.is-selected)');

  let mouseTimeIn  = 0;
  let mouseTimeOut = 0;
  let lastTargetValue = '';

  const currentColor = swatchMainColor.innerText;;

  labels.forEach((item, idx) => {
    item.addEventListener('mouseenter', (event) => {
        const targetValue = event.currentTarget.dataset.value;

        swatchGeneratedColor.innerHTML = targetValue;

        swatchGeneratedColor.classList.remove('show-from-bottom');
        swatchGeneratedColor.classList.add('fix');

        if ( swatchGeneratedColor.classList.contains( 'hide-from-center' ) ) {
          swatchMainColor.innerHTML = lastTargetValue;
          swatchGeneratedColor.style.top = '0';
        }
        else {
          swatchMainColor.innerHTML = currentColor;
        }

        swatchMainColor.classList.remove('show-from-bottom');
        swatchMainColor.classList.add('hide-from-center');

        swatchGeneratedColor.classList.remove('hide-from-center');
        swatchGeneratedColor.classList.add('show-from-bottom');

        setTimeout(() => {
          swatchGeneratedColor.classList.remove('fix');
        }, 1);

        if ( mouseTimeIn ) {
          window.clearTimeout( mouseTimeIn )
        }
        mouseTimeIn = setTimeout(() => {
          swatchMainColor.classList.remove('hide-from-center');
       }, 300 );

       lastTargetValue = targetValue;
    });

    item.addEventListener('mouseout', (event) => {
      event.preventDefault();
      swatchMainColor.innerHTML = currentColor;

      swatchMainColor.classList.remove('hide-from-center');
      swatchMainColor.classList.add('show-from-bottom');


      swatchGeneratedColor.classList.remove('show-from-bottom');
      swatchGeneratedColor.classList.add('hide-from-center');

      if ( mouseTimeOut ) {
        window.clearTimeout( mouseTimeOut )
      }
      mouseTimeOut = setTimeout(() => {
        swatchMainColor.classList.remove('hide-from-center');
        swatchGeneratedColor.classList.remove('hide-from-center');
     }, 300 );
    })
  });
});

$(document).on('click', '.product-card__quick-add-variants li', function(e) {
  e.preventDefault();
  $(this).siblings().removeClass('selected');
  $(this).addClass('selected');
  $(this).parent().siblings('.BIS_trigger').attr('data-variant-id', $(this).attr('data-variant-id'));
})

$(document).on('click', '.product-card__quick-add-btn', function(e) {
  e.preventDefault();

  let variant_id = Number($(this).siblings('.product-card__quick-add-variants').find('li.selected').data('variant-id'));

  console.log($(this));

  if ($(this).is('[final-sale]')) {
    var data = {
      "id": variant_id,
      "quantity": 1,
      "properties": {
        'NOTE': 'Final Sale'
      }
    }
  } else {
      var data = {
      "id": variant_id,
      "quantity": 1
    }
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.querySelector('.header__cart-link a').click();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,  //this code is for prestige theme, is to refresh the cart
        detail: {
          quantity: 1
        }
      }));
    }   
  }); 
  
})
